(() => {
  'use strict';
  const dialog = document.getElementById('haro-clinic-sample');
  if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
  dialog.dataset.initialized = 'true';
  const close = dialog.querySelector('[data-clinic-close]');
  const result = dialog.querySelector('[data-clinic-result]');
  const success = result?.getAttribute('role') === 'status';
  const hashes = ['#haro-clinic-sample', '#HaroClinicSampleForm', '#haro-partner-registration', '#haro-provider-contact'];
  const returningToConfirmation = success && (
    history.state?.haroClinicSampleConfirmed ||
    performance.getEntriesByType('navigation')[0]?.type === 'back_forward'
  );
  const interest = dialog.querySelector('#ClinicInterest');
  const alsoSample = dialog.querySelector('#ClinicAlsoSample');
  const country = dialog.querySelector('#ClinicCountry');
  const address = dialog.querySelector('[data-provider-address]');
  const sampleOnly = 'Request a clinic sample';
  const wantsSample = () => interest?.value === sampleOnly || Boolean(alsoSample?.checked);
  const updateAddressRequirements = () => {
    const required = country?.value === 'United States';
    ['ClinicRegion', 'ClinicPostal'].forEach(id => {
      const field = dialog.querySelector('#' + id);
      if (field) field.required = required;
    });
  };
  const updateRequest = () => {
    if (!interest) return;
    const sample = wantsSample();
    dialog.querySelector('[data-extra-sample]').hidden = interest.value === sampleOnly;
    alsoSample.disabled = interest.value === sampleOnly;
    dialog.querySelector('[data-partner-note]').hidden = interest.value === sampleOnly || interest.value === 'Provider team question';
    dialog.querySelectorAll('[data-sample-only]').forEach(group => {
      group.hidden = !sample;
      group.querySelectorAll('input, select, textarea').forEach(field => { field.disabled = !sample; });
    });
    dialog.querySelectorAll('[data-sample-required]').forEach(field => { field.required = sample; });
    dialog.querySelectorAll('[data-sample-star], [data-address-required]').forEach(el => { el.hidden = !sample; });
    dialog.querySelectorAll('[data-nonsample-only]').forEach(el => { el.hidden = sample; });
    if (address) address.open = true;
    dialog.querySelector('[data-provider-request-type]').value = interest.value + (sample && interest.value !== sampleOnly ? ' + clinic sample request' : '');
    dialog.querySelector('[data-provider-submit-label]').textContent = interest.value === sampleOnly ? (window.haroMessages?.send_sample_request_6800b || "Send sample request") : sample ? (window.haroMessages?.send_inquiry_sample_request_be07a || "Send inquiry & sample request") : (window.haroMessages?.send_to_the_provider_team_3549e || "Send to the provider team");
    const question = interest.value === 'Provider team question';
    dialog.querySelector('#ClinicNotes').required = question;
    dialog.querySelector('[data-provider-message-note]').textContent = question ? '*' : (window.haroMessages?.optional_00597 || "(optional)");
    updateAddressRequirements();
  };
  const intentFor = hash => hash === '#haro-partner-registration' ? 'Explore clinic partnership options' : hash === '#haro-provider-contact' ? 'Provider team question' : sampleOnly;
  const setInterest = value => {
    if (interest && Array.from(interest.options).some(option => option.value === value)) {
      interest.value = value;
      updateRequest();
    }
  };
  const url = new URL(location.href);
  const requestedInterest = url.searchParams.get('provider_interest');
  const intentStorageKey = 'haro-provider-request-intent';
  let returnedIntent;
  try {
    const saved = JSON.parse(sessionStorage.getItem(intentStorageKey) || 'null');
    if (result?.getAttribute('role') === 'alert' && saved?.path === location.pathname && Date.now() - saved.at < 30 * 60 * 1000) returnedIntent = saved;
    sessionStorage.removeItem(intentStorageKey);
  } catch { /* The form works without browser storage. */ }
  if (success) {
    // Consume this form's successful return without losing other page state.
    url.searchParams.delete('contact_posted');
    url.searchParams.delete('provider_interest');
    if (hashes.includes(url.hash)) url.hash = '';
    history.replaceState({ ...history.state, haroClinicSampleConfirmed: true }, '', url);
  } else {
    if (alsoSample) alsoSample.checked = returnedIntent?.sample === true;
    setInterest(requestedInterest || returnedIntent?.interest || intentFor(location.hash));
    if (requestedInterest) {
      url.searchParams.delete('provider_interest');
      history.replaceState(history.state, '', url);
    }
  }
  let opener;
  dialog.close();
  close.hidden = false;
  const open = (trigger, hash = location.hash) => {
    const intent = trigger?.dataset.providerIntent || intentFor(trigger?.hash || hash);
    if (success && trigger) {
      // A new inquiry after confirmation needs a fresh form, not the old result.
      const next = new URL(location.href);
      next.searchParams.set('provider_interest', intent);
      next.hash = trigger.hash;
      location.assign(next.href);
      return;
    }
    if (trigger) setInterest(intent);
    opener = trigger;
    if (!dialog.open) dialog.showModal();
    dialog.scrollTop = 0;
    dialog.dispatchEvent(new Event('haro:clinic-open'));
    if (result) result.focus();
  };
  document.querySelectorAll('a[href="#haro-clinic-sample"], a[href="#haro-partner-registration"], a[href="#haro-provider-contact"]').forEach(trigger => {
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', dialog.id);
    trigger.addEventListener('click', event => {
      event.preventDefault();
      open(trigger);
    });
  });
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener?.focus());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  // Keep native Shopify validation, spam protection and server-confirmed success.
  // No clinic contact details are stored in browser storage.
  interest?.addEventListener('change', updateRequest);
  alsoSample?.addEventListener('change', updateRequest);
  country?.addEventListener('change', updateAddressRequirements);
  dialog.querySelector('#ClinicAddress')?.addEventListener('change', event => {
    if (address && event.target.value) address.open = true;
  });
  dialog.querySelector('form')?.addEventListener('invalid', event => {
    if (address?.contains(event.target)) address.open = true;
  }, true);
  dialog.querySelector('form')?.addEventListener('submit', () => {
    // Preserve only the selected topic through a server validation error, never
    // names, addresses, contact information, or message content.
    if (!interest) return;
    try {
      sessionStorage.setItem(intentStorageKey, JSON.stringify({ interest: interest.value, sample: alsoSample.checked, path: location.pathname, at: Date.now() }));
    } catch { /* Optional state only; native Shopify submission still proceeds. */ }
  });
  updateRequest();
  window.addEventListener('hashchange', () => {
    if (hashes.includes(location.hash)) {
      setInterest(intentFor(location.hash));
      open();
    }
  });
  window.addEventListener('pagehide', () => {
    if (success && dialog.open) dialog.close();
  });
  window.addEventListener('pageshow', event => {
    if (success && event.persisted && dialog.open) dialog.close();
  });
  if (!returningToConfirmation && (result || hashes.includes(location.hash))) open();
})();
